import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";
import { logger } from "@/utils/logger";
import { queryClient } from "@/lib/react-query";

export const RealtimeSyncManager = () => {
  const { profile } = useAuth();

  useEffect(() => {
    if (!profile?.id) return;

    logger.info("Iniciando RealtimeSyncManager", "RealtimeSyncManager", {
      userId: profile.id
    });

    // Criar canal único para todas as mudanças
    const channel = supabase
      .channel('realtime-sync')
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'access_requests' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["access-requests"] });
          queryClient.invalidateQueries({ queryKey: ["my-access-requests"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'announcements' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["announcements"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'bookings' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["bookings"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'packages' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["packages"] });
          queryClient.invalidateQueries({ queryKey: ["resident-packages"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'common_areas' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["common-areas"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'common_area_rules' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["common-area-rules"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'conversations' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["conversations"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'conversation_participants' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["conversations"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'events' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["events"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'incidents' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["incidents"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'messages' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["messages"] });
          queryClient.invalidateQueries({ queryKey: ["conversations"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'packages' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["packages"] });
          queryClient.invalidateQueries({ queryKey: ["notifications"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'pets' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["pets"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'profiles' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["profiles"] });
          queryClient.invalidateQueries({ queryKey: ["auth"] });
          queryClient.invalidateQueries({ queryKey: ["available-users"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'timesheet_records' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["timesheet-records"] });
          queryClient.invalidateQueries({ queryKey: ["timesheets"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'timesheets' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["timesheets"] });
          queryClient.invalidateQueries({ queryKey: ["employee-hours-bank"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'units' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["units"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'visitors' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["visitors"] });
        }
      )
      .on(
        'postgres_changes',
        { event: '*', schema: 'public', table: 'staff_members' },
        () => {
          queryClient.invalidateQueries({ queryKey: ["staff-members"] });
          queryClient.invalidateQueries({ queryKey: ["archived-staff-members"] });
        }
      )
      .subscribe((status) => {
        logger.info("Status do canal realtime", "RealtimeSyncManager", { status });
      });

    return () => {
      logger.info("Removendo canal realtime", "RealtimeSyncManager");
      supabase.removeChannel(channel);
    };
  }, [profile?.id, queryClient]);

  return null;
};